var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("404 Not Found")]),_c('p',[_vm._v(" Oops we couldn't find that page. Try going "),_c('router-link',{attrs:{"to":{ name: 'Dashboard' }}},[_vm._v("Dashboard")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }